/**
 * So'rov (query) `meta` bayroqlari — `main.tsx` dagi global `QueryCache.onError` shu yerga qaraydi.
 *
 * `SILENT_ERROR` — sahifaning O'ZI xatoni ochiq ko'rsatadigan (Alert + "Qayta urinish")
 * so'rovlar uchun: global qizil toast ikkinchi marta shu haqda aytmasin. Boshqa barcha
 * so'rovlar toast oladi — aks holda xato jimgina "ma'lumot yo'q" bo'lib ko'rinardi.
 */
export const SILENT_ERROR = { skipErrorToast: true } as const;
